import config from '@/config'
const { cdn, onPointDumpsterColor } = config
export const BDMapConfig = {
  // Requires an API key with Google with PlacesAPI and GeolocationAPI enabled.
  googleApiKey: process.env.VUE_APP_ONPOINT_MAPS_KEY,
  geocodeApiKey: process.env.VUE_APP_ONPOINT_GEOCODE_KEY,
  mapDefaultCenterLocation: {
    lat: 41.4490608,
    lng: -81.9199357
  },
  dragHandle: {
    src: `${cdn}OnPoint-Polygon-Controls.svg`,
    width: 30,
    height: 72,
    rotation: 45
  },

  rotationAmount: 10, // degrees
  // include any overrides to google maps parameters for this specific application
  mapConfiguration: {
  },
  polygonConfiguration: {
    fillColor: onPointDumpsterColor
  },
  headingInstructions: "Move the dumpster to mark your desired drop location and click 'Confirm' to place it."
}
